import { Badge } from '@/components/ui/badge';
import { CheckCircle2, Clock, AlertCircle } from 'lucide-react';

export const StatusBadge = ({ status }) => {
  const variants = {
    paid: {
      variant: 'default',
      className: 'status-paid',
      icon: CheckCircle2,
      label: 'Paid',
    },
    pending: {
      variant: 'secondary',
      className: 'status-pending',
      icon: Clock,
      label: 'Pending',
    },
    overdue: {
      variant: 'destructive',
      className: 'status-overdue',
      icon: AlertCircle,
      label: 'Overdue',
    },
  };

  const config = variants[status] || variants.pending;
  const Icon = config.icon;

  return (
    <Badge className={`${config.className} gap-1`}>
      <Icon className="h-3 w-3" />
      {config.label}
    </Badge>
  );
};